import type { QuoteData } from '../types/quote.types';

/** The one notion of "live" the journey uses: an unsaved quote has no status yet, and only a
 *  live quote may be re-priced — a completed or dead one carries its as-sold figures already. */
export const isLiveQuote = (status: QuoteData['status']): boolean =>
    status === undefined || status === 'live';
